import React from "react";
import OptionList from "@JohnLewisPartnership/jl-design-system/dist/components/option/OptionList";
import RadioButton from "@JohnLewisPartnership/jl-design-system/dist/components/radio-button/RadioButton";
import { useState } from "react";
import styles from "./email-form.module.scss";

const map = new Map();
map.set("Refund", "The customer is requesting a REFUND.");
map.set("Replacement", "The customer is requesting a REPLACEMENT.");
map.set("Notsure", "The customer isn't sure if they would like a refund or replacement.");

const options = [
  { value: "Refund", label: "Refund" },
  { value: "Replacement", label: "Replacement (to same address)" },
  { value: "Notsure", label: "Other (including replacement to new address)" },
];

/**
 * @todo: Remove this file after the experiment of a live chat
 */
const PreferredResolution = ({ onChange }) => {
  const [value, setValue] = useState(false);

  const handleChange = e => {
    setValue(e.target.value);
    onChange(e.target.value);
  };

  return (
    <OptionList className={styles["radio-group-label"]} name="radio-button-group" isButtonList={true}>
      {options.map(option => (
        <RadioButton
          key={option.value}
          onChange={handleChange}
          value={option.value}
          label={option.label}
          checked={option.value === value}
        />
      ))}
    </OptionList>
  );
};

export const getPreferredResolutionDescription = key => map.get(key) || "";

export default PreferredResolution;
